export default "__VITE_ASSET__4b68ac50__"